import React, { useState, useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import NetworkApi from "../../services/networks";
import Error from "../../fragments/form/Error"
import Message from "../../fragments/form/Message"

function NetworkPage(props) {
    const { networkId } = useParams();
    const navigate = useNavigate();
    const [network, setNetwork] = useState(null);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);
    const networkApi = new NetworkApi(props.token);

    useEffect(() => {
        loadNetwork();
    }, [networkId]);

    const loadNetwork = async () => {
        try {
            const response = await networkApi.getById(networkId);
            setNetwork(response);
        } catch (error) {
            console.error("Error loading network:", error);
            setError("Failed to load network");
        }
    };

    if (!network) {
        return (
            <div className='dashboard-content'>
                <div className='dashboard-content-container'>
                    <div className='dashboard-content-header'>
                        <h2>Loading Network...</h2>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className='dashboard-content'>
            <div className='dashboard-content-container'>
                <div className='dashboard-content-header'>
                    <h2>Network Details</h2>
                    <div>
                        <button 
                            className="btn btn-primary"
                            onClick={() => navigate(`/network/${networkId}/edit`)}
                        >
                            Edit Network
                        </button>
                        <button 
                            className="btn btn-secondary ms-2"
                            onClick={() => navigate('/networks')}
                        >
                            Back to Networks
                        </button>
                    </div>
                </div>
                <Error message={error} />
                <Message message={message} />
                
                <div className="network-details">
                    <div className="row">
                        <div className="col-md-6">
                            <h4>Basic Information</h4>
                            <table className="table table-striped">
                                <tbody>
                                    <tr>
                                        <td><strong>ID:</strong></td>
                                        <td>{network.id}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Name:</strong></td>
                                        <td>{network.name}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Subdomain:</strong></td>
                                        <td>{network.subdomain || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Custom Domain:</strong></td>
                                        <td>{network.custom_domain || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Website:</strong></td>
                                        <td>{network.website_url || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Description:</strong></td>
                                        <td>{network.description || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Background Color:</strong></td>
                                        <td>
                                            <span 
                                                className="badge" 
                                                style={{backgroundColor: network.background_color, color: 'white'}}
                                            >
                                                {network.background_color || '#ffffff'}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><strong>Status:</strong></td>
                                        <td>
                                            <span className={`badge ${network.is_published ? 'bg-success' : 'bg-warning'}`}>
                                                {network.is_published ? 'Published' : 'Pending'}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-md-6">
                            <h4>Administrator Information</h4>
                            <table className="table table-striped">
                                <tbody>
                                    <tr>
                                        <td><strong>Administrator Name:</strong></td>
                                        <td>{network.admin_name || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Phone Number:</strong></td>
                                        <td>{network.admin_phone || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Email:</strong></td>
                                        <td>{network.admin_email || 'N/A'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    
                    <div className="row mt-4">
                        <div className="col-md-6">
                            <h4>Billing Information</h4>
                            <table className="table table-striped">
                                <tbody>
                                    <tr>
                                        <td><strong>Billing Information:</strong></td>
                                        <td>{network.billing_information}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Billing Date:</strong></td>
                                        <td>{network.billing_date}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Invoice Email:</strong></td>
                                        <td>{network.invoice_email}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-md-6">
                            <h4>Location Information</h4>
                            <table className="table table-striped">
                                <tbody>
                                    <tr>
                                        <td><strong>Address:</strong></td>
                                        <td>{network.address || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Address 2:</strong></td>
                                        <td>{network.address2 || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>City:</strong></td>
                                        <td>{network.city || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>State:</strong></td>
                                        <td>{network.state || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Country:</strong></td>
                                        <td>{network.country || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Zip Code:</strong></td>
                                        <td>{network.zip_code || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Latitude:</strong></td>
                                        <td>{network.latitude || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Longitude:</strong></td>
                                        <td>{network.longitude || 'N/A'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {network.image_url && (
                        <div className="row mt-4">
                            <div className="col-md-12">
                                <h4>Network Image</h4>
                                <img 
                                    src={network.image_url} 
                                    alt={network.name}
                                    className="img-fluid"
                                    style={{maxWidth: '300px', maxHeight: '300px'}}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default NetworkPage
